// extracted by mini-css-extract-plugin
module.exports = {"dialog--footer":"dialog--footer__HZNqB","dialog--footer__padding-off":"dialog--footer__padding-off__LHZXz"};